import { anim, stagger } from '../../../../motion'
import { Line } from '../../../../v2/kit'
import { useCopy, useLang, useTheme } from '../../../i18n'
import { toTop } from '../../../kit'
import { Magnetic, MaskText } from '../../stage/fx'

// Partikel formen ein Herz (Chancengeber), dann rahmen sie den Abschluss ein
const heart = (w, h, narrow) => ({
  type: 'heart',
  x: w / 2,
  y: narrow ? h * 0.32 : h * 0.34,
  size: narrow ? w * 0.66 : Math.min(h * 0.52, w * 0.36),
  dot: 0.8
})

export const CLOSE_PARTICLES = [
  [0.1, heart],
  [0.44, heart],
  [0.6, () => ({ type: 'frame', inset: 22 })],
  [1, () => ({ type: 'frame', inset: 22 })]
]

const BORDERS = ['#FE79A7', '#FFB628', '#43DBBD']

export default function DmsClose() {
  const c = useCopy('abschluss')
  const s = useCopy('show')
  const lang = useLang()
  const theme = useTheme()
  const candidateHref = `${window.location.pathname}?v=bewerbende-showcase${theme === 'light' ? '-hell' : ''}${
    lang === 'en' ? '&lang=en' : ''
  }`

  return (
    <div className='sc-full'>
      <div className='dms-close-hero'>
        <h2 className='sc-display'>
          <MaskText text={s.closeTitle} at={[0.16, 0.32]} out={[0.5, 0.56]} />
        </h2>
        <Line at={[0.3, 0.36]} out={[0.5, 0.56]} y={20} className='sc-lead'>
          {c.sub}
        </Line>
      </div>

      <div className='dms-close'>
        <div style={anim({ at: [0.6, 0.68], y: 50 })}>
          <div className='sc-eyebrow'>{c.why}</div>
          {c.points.map((p, i) => (
            <div
              key={p.title}
              className='dms-close__point'
              style={{ borderColor: BORDERS[i] }}
            >
              <div className='dms-close__title'>{p.title}</div>
              <div className='dms-close__text'>{p.text}</div>
            </div>
          ))}
        </div>
        <div>
          <div className='sc-eyebrow' style={anim({ at: [0.64, 0.7], y: 30 })}>
            {c.next}
          </div>
          <ol className='dms-next'>
            {c.steps.map((step, i) => (
              <li
                key={step.title}
                style={anim({ at: stagger(0.66, 0.03, 0.06, i), x: 40, y: 0 })}
              >
                <span>{i + 1}</span>
                <div>
                  <b>{step.title}</b>
                  <small>{step.text}</small>
                </div>
              </li>
            ))}
          </ol>
          <div className='dms-actions' style={anim({ at: [0.8, 0.88], y: 30 })}>
            <Magnetic
              href={c.ctaHref}
              target='_blank'
              rel='noreferrer'
              className='sc-btn'
            >
              {c.cta}
            </Magnetic>
            <Magnetic href={candidateHref} className='sc-btn sc-btn--ghost'>
              {c.candidate}
            </Magnetic>
            <Magnetic
              as='button'
              type='button'
              onClick={toTop}
              className='sc-btn sc-btn--ghost'
            >
              {c.again}
            </Magnetic>
          </div>
        </div>
      </div>
    </div>
  )
}
